import React from "react";
import PageHeader from "./PageHeader";
import ColorHistory from "./ColorHistory";
import SelectedColorDisplay from "./SelectedColorDisplay";

const ColorPaletteGenerator = ({
  baseColor,
  tempColor,
  onColorChange,
  onColorChangeComplete,
  colorBlindnessType,
  isDark,
  colorHistory = [],
  addColorToCustomPalette,
  clearColorHistory,
}) => {
  const handleColorClick = (color) => {
    onColorChangeComplete(color);
  };

  return (
    <div>
      <PageHeader
        title="Color Information"
        description="Color history and detailed information"
      />
      <div className="mb-6" />
      <div className="space-y-6">
        <ColorHistory
          colors={colorHistory}
          onColorClick={handleColorClick}
          addColorToCustomPalette={addColorToCustomPalette}
          clearColorHistory={clearColorHistory}
        />
        <SelectedColorDisplay color={tempColor} />
      </div>
    </div>
  );
};

export default ColorPaletteGenerator;